import { useState, useEffect, useRef } from 'react';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel, user as userModel, rtc, speakWeight } from '@/models';

// let getVoiceLevelTimer: any = 0;
export default function useLocalStreamVoice() {
  const {
    user,
    meeting,
    rtc: RTCInstance,
  } = useLocalStore(() => {
    return {
      user: userModel,
      meeting: meetingModel,
      rtc,
    };
  });
  const getVoiceLevelTimer = useRef<any>(null);

  useEffect(() => {
    // 获取本端的声音大小(声音采集 不是音频播放的声音大小)
    if (RTCInstance.localStream) {
      if (getVoiceLevelTimer.current) {
        return;
      }
      getVoiceLevelTimer.current = setInterval(() => {
        // client 存在就表示本端流已经初始化完成了
        if (RTCInstance?.client) {
          const voiceLevel =
            RTCInstance && RTCInstance.localStream && RTCInstance.localStream.getAudioLevel();
          if (voiceLevel > 0) {
            meeting?.setSpeakerYxUid(user.yxuid);
            speakWeight.setUserWeight(user.yxuid, voiceLevel);
          } else {
            speakWeight.setUserWeight(user.yxuid, 0);
          }
        }
      }, 1000);
    }
    if (!RTCInstance.isOpenAudio) {
      // clearInterval(getVoiceLevelTimer);
      meeting?.setSpeakerYxUid('');
    }
  }, [RTCInstance, RTCInstance.localStream, RTCInstance.isOpenAudio, RTCInstance.client]);

  useEffect(() => {
    return () => {
      getVoiceLevelTimer && clearInterval(getVoiceLevelTimer.current);
    };
  }, []);
}
